<app-vo-side-menu></app-vo-side-menu>
<app-vo-notifiation *ngIf="showNotification" [companyId]="companyId" (dismiss)="dismiss($event)"></app-vo-notifiation>
<div class="reflow-container">
  <router-outlet></router-outlet>
</div>